// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"608":"2d23312d","724":"5e32ef17","840":"964c927b","904":"b43e1b9b"}[chunkId] + ".chunk.js";
};